/* eslint-disable import/prefer-default-export */
import Immutable from 'seamless-immutable';
import { tWind } from 'utils/translates';
import { reducerName, createActionName } from './naming';
import * as types from './actionsTypes';
import {
  createValidateObject,
  storeSetFieldValue
} from '../../../../utils/reducerHalpers/formFields';
import * as validateTypes from '../../../../utils/reducerHalpers/validateTypes';

const createCommentFormReducer = name => {
  function stateDefault() {
    return {
      sumIncludeCommission: 0,
      commissionPercent: 6,
      commissionDesc: '',
      fields: {
        sum: {
          title: tWind('Сумма пополнения'),
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        },
        paymentSystem: {
          title: tWind('Платежная система'),
          value: '1',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }
      },
      resultObject: {}
    };
  }

  function calculateHandle(state, sum) {
    const sumIncludeCommission =
      sum !== ''
        ? parseFloat(sum) +
          parseFloat(sum) * parseFloat(`0.0${state.commissionPercent}`)
        : 0;
    let commissionDesc;
    if (['1', '3'].includes(state.fields.paymentSystem.value)) {
      commissionDesc = tWind(
        `С учетом комиссии {commissionPercent}% = {sumIncludeCommission}₽`,
        {
          commissionPercent: state.commissionPercent,
          sumIncludeCommission
        },
        { state }
      );
    } else {
      const descSum = sum || 0;
      commissionDesc = tWind(
        `{descSum}₽ + комиссия платежной системы в зависимости от типа платежа`,
        { descSum }
      );
    }

    return state.merge({
      sumIncludeCommission,
      commissionDesc
    });
  }
  const initialState = calculateHandle(Immutable(stateDefault()), 0);
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, types.SEND_FORM):
        return state;
      case createActionName(name, types.SET_FIELD_SUM): {
        const newState = calculateHandle(state, action.payload);
        return storeSetFieldValue(newState, 'sum', action.payload);
      }
      case createActionName(name, types.SET_PAYMENT_SYSTEM): {
        const newState = storeSetFieldValue(
          state,
          'paymentSystem',
          action.payload
        );
        return calculateHandle(newState, state.fields.sum.value);
      }
      case createActionName(name, types.SET_RESULT_OBJECT):
        return state.merge({
          resultObject: action.payload
        });
      case createActionName(name, types.INIT_STATE):
        return Immutable(stateDefault());
      default:
        return state;
    }
  };
};

export function createReduceObject(parentName) {
  const reduceObject = {};
  reduceObject[reducerName] = createCommentFormReducer(parentName);
  return reduceObject;
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/payment/reducers/paymentForm/reducer.js